import { Grid, Typography } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import { useState, useEffect } from "react";
import useTabStyles from "../../styles/useTabStyles";
import useTableStyles from "../../styles/useTableStyles";

export type TabSectionProps = {
  tabList: string[];
  setParentTabState?: Function;
  defaultTab?: string;
};

const RoleManagementTabs: React.FunctionComponent<TabSectionProps> = (
  props: TabSectionProps
) => {
  const { tabList, setParentTabState, defaultTab } = props;
  const tabStyes = useTabStyles();
  const tableStyle = useTableStyles();
  const [activeTab, setActiveTab] = useState<string>(tabList[0]);
  const theme = useTheme();
  const handleTabSelection = (e: React.SyntheticEvent) => {
    const { innerText } = e.target as HTMLElement;
    setActiveTab(innerText);
  };

  useEffect(() => {
    if (setParentTabState && defaultTab) {
      setParentTabState(defaultTab);
      setActiveTab(defaultTab);
    }
  }, [defaultTab]);

  useEffect(() => {
    setActiveTab(activeTab);
    if (setParentTabState instanceof Function) setParentTabState(activeTab);
  }, [activeTab]);

  return (
    <Grid
      display={"flex"}
      height={"100%"}
      width={"100%"}
      gap={2}
      sx={{ overflowX: "auto", ...tableStyle.scrollbar }}
    >
      {tabList.map((tab, i) => {
        return (
          <Grid
            item
            height={"90%"}
            width={"auto"}
            justifyContent={"center"}
            key={i}
            px={1}
            sx={{ whiteSpace: "nowrap" }}
          >
            <Typography
              // px={1}
              height={"100%"}
              color={theme?.color?.primary}
              display={"flex"}
              alignItems={"center"}
              justifyContent={"center"}
              fontFamily={theme.font?.fontFamily.primary}
              fontSize={theme.font?.fontSize.cardHeader}
              sx={
                activeTab === tab
                  ? { ...tabStyes.active, ...tabStyes.hover }
                  : { ...tabStyes.hover }
              }
              onClick={handleTabSelection}
            >
              {tab}
            </Typography>
          </Grid>
        );
      })}
    </Grid>
  );
};

export default RoleManagementTabs;
